import { createElement } from "react";
/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';
const plus = createElement(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, createElement(Path, {
  d: "M18 11.2h-5.2V6h-1.6v5.2H6v1.6h5.2V18h1.6v-5.2H18z"
}));
export default plus;
//# sourceMappingURL=plus.js.map